import { setRefreshStatus } from '../actions/internalActions';
import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';

mutator(setRefreshStatus, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);

    sharingLink.linkActionStatus = actionMessage.actionStatus;
});
